import React from "react";

import BannerCheckList from "../../../../common/BannerCheckList";
import CountdownTimer from "../../Homepage/components/CountdownTimer";
import FormatCurrency from "../../Homepage/components/FormatCurrency";

const BonusSquare = ({ currentOffer, locale, translate }) => {
  const checklistItems =
    currentOffer?.bonus?.items?.map(({ title, description, value }) => ({
      key: title,
      title: title || null,
      description: description || null,
      meta:
        value > 0 ? (
          <span className="text-xs.1 text-white font-medium opacity-60">
            {translate("plans_bonus_value")}
            <FormatCurrency locale={locale} value={value} />
          </span>
        ) : null
    })) ?? [];

  return (
    <div className={"rounded-2xl bg-banner flex flex-col gap-4 p-4"}>
      <h2 className={"text-xl"}>
        <span className={"text-yellow"}>
          {translate("plans_bonus_heading")}
        </span>
        <span className={"font-bold text-white"}>
          {currentOffer.bonus.plans.join(", ")}
        </span>
      </h2>
      {currentOffer.bonus?.expires_on ? (
        <div className={"flex box-1 gap-4 max-w-2xl.3 w-content"}>
          <CountdownTimer
            targetTime={new Date(currentOffer.bonus.expires_on).getTime()}
          />
        </div>
      ) : null}
      <div className={"flex gap-3"}>
        {currentOffer.bonus.image ? (
          <img
            width={107}
            height={107}
            src={currentOffer.bonus.image}
            alt={""}
          />
        ) : null}
        <div className={"flex justify-between align-end"}>
          <BannerCheckList items={checklistItems} />
        </div>
      </div>
    </div>
  );
};

export default BonusSquare;
